import {Columns} from '@shared/interfaces/table/column-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const meterreadingtypePartial: Columns<any> = {
  title: 'meter.readingTypes.title',
  key: 'meterReadingType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meter.readingTypes.NotSpecified',
    accumulated: 'meter.readingTypes.Accumulated',
    balanced: 'meter.readingTypes.Balanced',
    none: 'meter.readingTypes.None'
  }
}
